import React from 'react'
import { useWizardMaster } from '../../../../../Contexts/WizardMasterContext'
import { Select } from 'antd'

const { Option } = Select

export const CounterPartySelect = ({ defaultCounterparty, accessor }) => {
  const { updateBackhaulField, backhaulMeta } = useWizardMaster()
  const selectOnChange = (value) => {
    updateBackhaulField(accessor, value)
  }
  return (
    <Select
      style={{ minWidth: 150 }}
      defaultValue={backhaulMeta && backhaulMeta.counterparties.find((o) => o === defaultCounterparty)}
      optionFilterProp='children'
      showSearch
      onSelect={selectOnChange}
    >
      {backhaulMeta &&
        backhaulMeta.counterparties.map((cp, i) => (
          <Option key={i} value={cp}>
            {cp}
          </Option>
        ))}
    </Select>
  )
}
